import "./Footer.css";

function Footer({
  textColor = "#fff"
}) {
  const startYear = 2026;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" >
      <p style={{ color:  textColor}}>
        &copy; {startYear}
        {currentYear > startYear && ` – ${currentYear}`} BleuSite. All rights
        reserved.
      </p>
    </footer>
  );
}

export default Footer;
